/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { RowOut } from './rowOut';

export interface QueryOut {
  rows: RowOut[];
  total: number;
  page: number;
  per_page: number;
  columns_version: string;
}
